<div *ngIf="backdropMode === 'gradient' && palette" class="header-backdrop header-backdrop--gradient"
     [style.--header-gradient-top]="palette.top" [style.--header-gradient-bottom]="palette.bottom" aria-hidden="true"></div>
<div *ngIf="backdropMode === 'blur' && backdropUrl as backdrop" class="header-backdrop" aria-hidden="true">
  <img *ngIf="(backdrop | offlineMedia:'image' | async) as backdropSrc"
       class="header-backdrop__image"
       [class.header-backdrop__image--loaded]="loadedUrl === backdrop"
       [src]="backdropSrc"
       (load)="onBackdropLoad(backdrop)"
       (error)="onBackdropError(backdrop)"
       decoding="async" alt="">
</div>
<ng-content></ng-content>
